import { tabReducer } from "./tabReducer";
import { tabReportReducer } from "./tabReportReducer";

const tabReducers = {
  tab: tabReducer,
  tabReport: tabReportReducer
};

export default tabReducers;